export default [
  {
    disabled: false,
    curated: true,
    title: 'Carolina Herrera',
    type: 'editor',
    date: '2026-03T00:00',
    filter: 'commercial',
    url: 'https://player.vimeo.com/video/1184269280',
  },
  {
    disabled: false,
    curated: true,
    title: 'Apple Bad Bunny',
    type: 'assistant editor',
    date: '2026-02T00:00',
    filter: 'commercial',
    url: 'https://player.vimeo.com/video/1184269267',
  },
  {
    disabled: false,
    title: 'Doordash',
    type: 'assistant editor',
    date: '2026-02T00:00',
    filter: 'commercial',
    url: 'https://player.vimeo.com/video/1184269205',
  },
  {
    disabled: false,
    title: 'Verizon',
    type: 'assistant editor',
    date: '2025-09T00:00',
    filter: 'commercial',
    url: 'https://player.vimeo.com/video/1163255942',
  },
  {
    disabled: false,
    curated: true,
    title: 'OFF WHITE nyfw 25',
    type: 'editor',
    date: '2025-09T00:00',
    filter: 'independent',
    url: 'https://player.vimeo.com/video/1163256047',
  },
  {
    disabled: false,
    curated: true,
    title: 'Your City By Diana',
    type: 'editor',
    date: '2025-10T00:00',
    filter: 'independent',
    url: 'https://player.vimeo.com/video/1163256130',
  },
  {
    disabled: false,
    curated: true,
    title: 'Radar.com',
    type: 'editor',
    date: '2025-10T00:00',
    filter: 'commercial',
    url: 'https://player.vimeo.com/video/1163256316',
  },
  {
    disabled: false,
    title: 'Verizon Frontline',
    type: 'assistant editor',
    date: '2025-10T00:00',
    filter: 'commercial',
    url: 'https://player.vimeo.com/video/1163256488',
  },
  {
    disabled: false,
    curated: true,
    title: 'Nike',
    type: 'assistant editor',
    date: '2025-12T00:00',
    filter: 'commercial',
    url: 'https://player.vimeo.com/video/1163256592',
  },
  {
    disabled: false,
    title: 'NBA Playoffs 2025',
    type: 'assistant editor',
    date: '2025-04T00:00',
    filter: 'commercial',
    url: 'https://player.vimeo.com/video/1093237203',
  },
  {
    disabled: false,
    title: 'Google Project Astra',
    type: 'assistant editor',
    date: '2024-12T00:00',
    filter: 'commercial',
    url: 'https://www.youtube.com/embed/DuA8U4Cfh2Q?si=4jHSDYSA4FHSajJw',
  },
  {
    disabled: false,
    title: 'Dunkin Sizzle',
    type: 'editor',
    date: '2022-10T00:00',
    filter: 'commercial',
    url: 'https://player.vimeo.com/video/1010079028',
  },
  {
    disabled: false,
    curated: true,
    title: 'Climate Integrity',
    type: 'editor',
    date: '2022-12T00:00',
    filter: 'commercial',
    url: 'https://player.vimeo.com/video/1010078982',
  },
  {
    disabled: false,
    title: 'Us Cellular Sizzle',
    type: 'editor',
    date: '2024-07T00:00',
    filter: 'commercial',
    url: 'https://player.vimeo.com/video/1010079084',
  },
  {
    disabled: false,
    title: 'Geico',
    type: 'editor',
    date: '2024-08T00:00',
    filter: 'commercial',
    url: 'https://player.vimeo.com/video/1010079056',
  },
  {
    disabled: false,
    curated: true,
    title: 'YooHoo',
    type: 'director-editor',
    date: '2024-08T00:00',
    filter: 'freelance',
    url: 'https://player.vimeo.com/video/1010079117',
  },
  {
    disabled: false,
    curated: true,
    title: 'OFF WHITE Celebs',
    type: 'editor',
    date: '2024-09T00:00',
    filter: 'freelance',
    url: 'https://player.vimeo.com/video/1010079070',
  },
  {
    disabled: false,
    curated: true,
    title: 'OFF WHITE nyfw 24',
    type: 'editor',
    date: '2024-09T00:00',
    filter: 'freelance',
    url: 'https://player.vimeo.com/video/1010079076',
  },
  {
    disabled: false,
    curated: true,
    title: 'COS nyfw 24',
    type: 'editor',
    date: '2024-09T00:00',
    filter: 'freelance',
    url: 'https://player.vimeo.com/video/1010079007',
  },
  {
    disabled: false,
    title: 'La Bella Cubana',
    type: 'director-editor',
    date: '2024-06T00:00',
    filter: 'freelance',
    url: 'https://player.vimeo.com/video/972519385',
  },
  {
    disabled: false,
    title: 'McDonalds',
    type: 'assistant editor',
    date: '2024-04T00:00',
    filter: 'commercial',
    url: 'https://player.vimeo.com/video/972512684',
  },
  {
    disabled: false,
    title: 'Volkswagen',
    type: 'assistant editor',
    date: '2024-02T00:00',
    filter: 'commercial',
    url: 'https://player.vimeo.com/video/972512645',
  },
  {
    disabled: false,
    title: 'SeatGeek',
    type: 'assistant editor',
    date: '2023-11T00:00',
    filter: 'commercial',
    url: 'https://player.vimeo.com/video/892776363',
  },
  {
    disabled: false,
    title: 'Sanches Home',
    type: 'director-editor',
    date: '2023-10T00:00',
    filter: 'freelance',
    url: 'https://player.vimeo.com/video/906901434',
  },
  {
    disabled: false,
    title: 'Carnival Cruises',
    type: 'assistant editor',
    date: '2023-09T00:00',
    filter: 'commercial',
    url: 'https://player.vimeo.com/video/892776349',
  },
  {
    disabled: false,
    curated: true,
    title: 'COS nyfw 23',
    type: 'editor',
    date: '2023-09T00:00',
    filter: 'freelance',
    url: 'https://player.vimeo.com/video/906901356',
  },
  {
    disabled: false,
    title: 'America Erased',
    type: 'editor',
    date: '2023-08T00:00',
    filter: 'commercial',
    url: 'https://player.vimeo.com/video/892776339',
  },
  {
    disabled: false,
    title: 'AutoTrader',
    type: 'assistant editor',
    date: '2023-06T00:00',
    filter: 'commercial',
    url: 'https://player.vimeo.com/video/892776327',
  },
  {
    disabled: false,
    title: 'KeyBank',
    type: 'assistant editor',
    date: '2023-05T00:00',
    filter: 'commercial',
    url: 'https://player.vimeo.com/video/892776311',
  },
  {
    disabled: false,
    curated: true,
    title: 'Hugo Boss',
    type: 'editor',
    filter: 'freelance',
    date: '2023-03T00:00',
    url: 'https://player.vimeo.com/video/906901420',
  },
  {
    disabled: false,
    title: 'Doordash Superbowl',
    type: 'assistant editor',
    filter: 'commercial',
    date: '2023-02T00:00',
    url: 'https://player.vimeo.com/video/892116964',
  },
  {
    disabled: false,
    title: 'Budlight Superbowl',
    type: 'assistant editor',
    filter: 'commercial',
    date: '2023-01T00:00',
    url: 'https://player.vimeo.com/video/892116952',
  },
  {
    disabled: false,
    title: 'Dunkin',
    type: 'assistant editor',
    filter: 'commercial',
    date: '2022-09T00:00',
    url: 'https://player.vimeo.com/video/1077679347',
  },
  {
    disabled: false,
    title: 'Mananalu',
    type: 'assistant editor',
    filter: 'commercial',
    date: '2022-09T00:00',
    url: 'https://player.vimeo.com/video/892116936',
  },
  {
    disabled: false,
    title: 'WellsFargo',
    type: 'assistant editor',
    filter: 'commercial',
    url: 'https://player.vimeo.com/video/892116928',
    date: '2022-08T00:00',
  },
  {
    disabled: false,
    title: 'McDonalds',
    type: 'assistant editor',
    filter: 'commercial',
    date: '2022-06T00:00',
    url: 'https://player.vimeo.com/video/892116919',
  },
  {
    disabled: false,
    title: 'Midea',
    type: 'assistant editor',
    filter: 'commercial',
    date: '2022-05T00:00',
    url: 'https://player.vimeo.com/video/1077679390',
  },
  {
    disabled: false,
    title: 'Paramount+',
    type: 'assistant editor',
    filter: 'commercial',
    date: '2022-03T00:00',
    url: 'https://player.vimeo.com/video/892118443',
  },
  {
    disabled: false,
    title: 'Penfed',
    type: 'assistant editor',
    filter: 'commercial',
    date: '2022-02T00:00',
    url: 'https://player.vimeo.com/video/892116900',
  },
  {
    disabled: false,
    title: 'DSG',
    type: 'assistant editor',
    filter: 'commercial',
    date: '2021-12T00:00',
    url: 'https://player.vimeo.com/video/1077679325',
  },
  {
    disabled: false,
    title: 'Statefarm',
    type: 'assistant editor',
    filter: 'commercial',
    date: '2021-10T00:00',
    url: 'https://player.vimeo.com/video/1077679432',
  },
  {
    disabled: false,
    title: 'Sprite',
    type: 'assistant editor',
    filter: 'commercial',
    date: '2021-10T00:00',
    url: 'https://player.vimeo.com/video/892116876',
  },
  {
    disabled: false,
    title: 'Dopesick',
    type: 'editor',
    filter: 'freelance',
    date: '2019-09T00:00',
    url: 'https://player.vimeo.com/video/906901380',
  },
  {
    disabled: false,
    curated: true,
    title: 'Harley Davidson',
    type: 'director-editor',
    filter: 'freelance',
    date: '2019-01T00:00',
    url: 'https://player.vimeo.com/video/906901394',
  },
  {
    disabled: false,
    title: 'College Archives pt. 3',
    type: 'director-editor',
    filter: 'freelance',
    date: '2018-05T00:00',
    url: 'https://player.vimeo.com/video/906901332',
  },
  {
    disabled: false,
    title: 'College Archives pt. 2',
    type: 'director-editor',
    filter: 'freelance',
    date: '2017-05T00:00',
    url: 'https://player.vimeo.com/video/906901315',
  },
  {
    disabled: false,
    title: 'College Archives pt. 1',
    type: 'director-editor',
    filter: 'freelance',
    date: '2016-12T00:00',
    url: 'https://player.vimeo.com/video/906901290',
  },
]
